module.exports = __webpack_public_path__ + "static/media/image_76.ffff0bbd.png";